import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { reveal } from "@/components/site/motionPresets";

/**
 * A price-free pointer to /services, for people who scroll past the nav.
 *
 * Deliberately lighter than Ecosystem above it: prose only, no cards, no
 * SpecList, no screenshots. Products lead, this supports. If it ever grows
 * comparable visual weight it has stopped doing its job.
 *
 * ⚠️ No prices here, and no price-teaser wording either — not the anchoring
 * phrases that imply a lowest tier, since those are prices without the digits.
 * The numbers live on /services and only there. The second
 * sentence covers all four offers in one breath on purpose; the itemised list
 * belongs on the services page.
 *
 * The id is `client-work`, not `services`: the nav's Services item is a route
 * link to /services, and a same-named homepage anchor would be an ambiguous
 * target.
 */
export default function ClientWork() {
  return (
    <section
      id="client-work"
      data-testid="client-work-section"
      aria-label="Client work at OneVidaria Digital"
      className="relative pt-28 sm:pt-36 pb-12 sm:pb-16"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div {...reveal({ y: 20, duration: 0.8, margin: "-80px" })}>
          <h2
            data-testid="client-work-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight text-white"
          >
            Client work
          </h2>

          <div className="mt-8 max-w-[64ch] space-y-5">
            <p className="text-base leading-relaxed text-white/70">
              We take on a small number of client sites. It funds the product
              work, and it keeps us close to the problems real businesses have
              on the web.
            </p>
            <p className="text-base leading-relaxed text-white/70">
              We build one-page sites, keep them running, and handle the social
              basics.
            </p>
          </div>

          <Link
            to="/services"
            data-testid="client-work-services-link"
            className="group mt-8 inline-flex min-h-[44px] items-center gap-2 rounded-sm text-sm text-[#10B981] transition-colors hover:text-[#34D399]"
          >
            See services and pricing
            <ArrowRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-0.5"
            />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
